import qs from "qs";

const API_BASE = "https://app.happi.team/api/";
// const API_BASE = "http://happi.test/api/";

type HTTPMethod =
  | "get"
  | "post"
  | "put"
  | "patch"
  | "delete"
  | "head"
  | "options";
type RequestParams = Record<string, any>;

const makeRequest = async (
  requestType: HTTPMethod,
  publishableKey: string,
  url: string,
  params: RequestParams
) => {
  return await fetch(`${API_BASE}${publishableKey}${url}`, {
    method: requestType,
    headers: {
      "Content-Type": "application/json",
    },
    mode: "cors",
    credentials: "same-origin",
    body: JSON.stringify(params),
  });
};

export const getRequest = async (
  publishableKey: string,
  url: string,
  params: RequestParams = {}
) => {
  const queryString = qs.stringify(params);
  return await fetch(`${API_BASE}${publishableKey}${url}?${queryString}`, {
    credentials: "same-origin",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const postRequest = async (
  publishableKey: string,
  url: string,
  params: RequestParams = {}
) => await makeRequest("post", publishableKey, url, params);
export const putRequest = async (
  publishableKey: string,
  url: string,
  params: RequestParams = {}
) => await makeRequest("put", publishableKey, url, params);
export const patchRequest = async (
  publishableKey: string,
  url: string,
  params: RequestParams = {}
) => await makeRequest("patch", publishableKey, url, params);
export const deleteRequest = async (
  publishableKey: string,
  url: string,
  params: RequestParams = {}
) => await makeRequest("delete", publishableKey, url, params);

export default {
  getRequest,
  postRequest,
  putRequest,
  patchRequest,
  deleteRequest,
};
